// extracted by mini-css-extract-plugin
module.exports = {"openInSnapchatCTA":"OpenInAppCTA_openInSnapchatCTA__xOUdP","ctaText":"OpenInAppCTA_ctaText__GPcCH"};